export interface CosmeticVisual {
  suit: number;
  accent: number;
}

const cosmeticVisuals: Readonly<Record<string, CosmeticVisual>> = {
  yard_orange: { suit: 0xff6b24, accent: 0x80fff0 },
  oxide_teal: { suit: 0x3faea5, accent: 0xffd166 },
  signal_violet: { suit: 0x8f75df, accent: 0xff8a4f },
  whiteout: { suit: 0xd7e4e2, accent: 0x72baff },
  brass_crown: { suit: 0xc18c35, accent: 0xffe49a },
};

export function cosmeticVisual(id?: string): CosmeticVisual | null {
  return id ? cosmeticVisuals[id] ?? null : null;
}

export function cosmeticCSSColor(color: number): string {
  return `#${color.toString(16).padStart(6, '0')}`;
}
